/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_3_QInputs */

const en_mk_pricing_faq_3_q = /** @type {(inputs: Mk_Pricing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I pay?`)
};

const id_mk_pricing_faq_3_q = /** @type {(inputs: Mk_Pricing_Faq_3_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana cara bayar?`)
};

/**
* | output |
* | --- |
* | "How do I pay?" |
*
* @param {Mk_Pricing_Faq_3_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_3_q = /** @type {((inputs?: Mk_Pricing_Faq_3_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_3_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_3_q(inputs)
	return en_mk_pricing_faq_3_q(inputs)
});